<template>
  <div class="container" id="booking">
    <div class="row">
      <div class="col-12">
        <div class="webpage-section-header  text-center" >
          RESERVATION
          <div class="under-bar"></div>
        </div>
      </div>
    </div>
    <div class="row" v-if="merchantItem !== null && merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.booking_message !== undefined && merchantItem.webSetting.booking_message !== null && merchantItem.webSetting.booking_message.length > 0">
      <div class="col-12" v-html="merchantItem.webSetting.booking_message.replace(/\n/g, '<br />')">

      </div>
    </div>
    <div class="row" v-if="bookingTypes.length > 1">
      <div class="col-12 booking-type-container" >
        <div class="booking-type" v-for="type in bookingTypes" v-bind:class="{'selected' : bookingItem !== false && bookingItem.bookingType === type.title}" v-on:click="onTypeSelected(type)">
          <div class="booking-type-title">
            {{type.title}}
          </div>
          <div class="booking-type-description" v-if="type.description !== undefined && type.description !== null && type.description.length > 0">
            {{type.description}}
          </div>
        </div>
      </div>
    </div>
    <template  v-if="bookingItem !== false">
      <div class="row booking-form-row text-left">

        <div class="col-12 text-center" v-if="bookingItem.typeList.length > 0">

          <strong>Table Type Selection</strong>
          <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
            <div v-for="type in bookingItem.typeList" class="round-selector" v-bind:class="{'selected': bookingItem.tableType === type}" v-on:click="selectSubType(type)">{{type}}</div>
          </div>
        </div>
        <div class="col-12 col-md-4">

          Date <span v-if="bookingItem !== null && bookingItem !== false && bookingItem.lastDay !== null">(up to {{bookingItem.lastDay}})</span>
          <div class="white-input" style="border-radius: 0.25rem;">
            <date-picker style="width: 100%; "
                         :lang="'en'"
                         class="date-picker"
                         input-class="date-picker"
                         v-model="bookingItem.bookingDate"
                         typable="false"
                         placeholder="Select Date"
                         valueType="format"
                         @change="onBookingDateSelected"></date-picker>
          </div>
  <!--        <input class="form-control" type="date" v-model="bookingItem.bookingDate" v-on:change="onBookingDateSelected"></input>-->
        </div>

        <div class="col-12 col-md-4">
          Time
          <select class="form-control" v-model="bookingItem.bookingTime" @change="timeSelected" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">
            <option value="0">
              <span v-if="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">Select Date to get time list</span>
              <span v-else>Select Time</span>
            </option>
            <option v-if="bookingItem.slots.length > 0" v-for="slot in bookingItem.slots" :value="slot.time" :disabled="slot.available === false">{{slot.text}}
              <span v-if="slot.available === false">{{slot.message.length > 0?' '+ slot.message:' Full'}} </span><span v-else> / {{slot.minGuest}}~{{slot.maxGuest}} guests</span>
            </option>
          </select>
        </div>
      </div>

      <div class="row booking-form-row text-left" v-if="bookingItem.bookingDate !== null && bookingItem.bookingDate.length > 0 && bookingItem.bookingTime !== null && bookingItem.bookingTime !== '0'">
        <div class="col-12 col-md-4">
          <span  v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && parseInt(merchantItem.webSetting.bookingChildrenEnabled) === 1">
          Number of Adults (over 10 years old)
          </span>
          <span v-else>
            Number of Guests
          </span>
          <select class="form-control" v-model="bookingItem.headCount" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null" @change="onHeadCountChanged">
            <option value="0">
              <span v-if="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">Select Date to get capacity</span>
              <span v-else>Number of Guests </span>
            </option>
            <template v-for="(c, ci) in bookingItem.maxBooking">
              <option v-if="c > 1 && c >= bookingItem.minBooking" :value="c">{{c}} Adults</option>
            </template>
          </select>
        </div>
        <div class="col-12 col-md-4" v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && parseInt(merchantItem.webSetting.bookingChildrenEnabled) === 1">
          Number of children (5~10 years old)
          <select class="form-control" v-model="bookingItem.children" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">
            <option value="0">No children
            </option>
            <template v-for="(c, ci) in 10">
              <option :value="c">{{c}} Child<span if="c > 1">ren</span></option>
            </template>
          </select>
        </div>
        <div class="col-12 col-md-4">
          Number of toddlers ( age of 4 or under)
          <select class="form-control" v-model="bookingItem.infants" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">
            <option value="0">No Toddlers
            </option>
            <template v-for="(c, ci) in 10">
              <option :value="c">{{c}} Toddler<span v-if="c > 1">s</span></option>
            </template>
          </select>
        </div>
      </div>
      <div class="row booking-form-row text-left" v-if="bookingItem.headCount > 0">
        <div class="col-12 col-md-4">
          Name
          <input class="form-control" type="text" v-model="bookingItem.name" placeholder="Name">
        </div>
        <div class="col-12 col-md-4">
          Mobile Number
          <div class="phone-input-row">
            <button
              type="button"
              class="form-control phone-country-select"
              @click="openCountryPicker"
              aria-haspopup="listbox"
              :aria-expanded="showCountryPicker ? 'true' : 'false'"
            >
              <span class="phone-country-selected">
                <template v-if="selectedCountry">
                  {{ countryCodeToFlag(selectedCountry.code) }} {{ selectedCountry.mobileCode }}
                </template>
                <template v-else>{{ bookingItem.countryCode }}</template>
              </span>
              <i class="fas fa-chevron-down phone-country-chevron" aria-hidden="true"></i>
            </button>
            <input type="tel" class="form-control phone-number-input" v-model="bookingItem.phoneNumber" placeholder="Phone number"/>
          </div>
        </div>

        <div class="col-12 col-md-6">
          Email
          <input class="form-control" type="text" style="text-transform: lowercase;" v-model="bookingItem.email" placeholder="Email">

        </div>
        <div class="col-12 col-md-6">
          <div>Email confirmation</div>
          <input class="form-control" type="text" style="text-transform: lowercase;" v-model="bookingItem.emailConfirm" placeholder="Email Confirmation">

        </div>
        <div class="col-12">
          <span style="color:red;">* Incorrect email will prevent us from sending you confirmation or notification email</span>
        </div>
        <div class="col-12 text-left">
          Special Request
          <textarea class="form-control" rows="3" v-model="bookingItem.note" placeholder="Special Request"/>
        </div>
        <div class="col-12 text-left">
          <span v-if="bookingItem.allowMerchantPromotion === true" style="font-size: 22px; color: #2F77E4;" @click="bookingItem.allowMerchantPromotion = !bookingItem.allowMerchantPromotion"><i class="fas fa-check-square"></i></span>
          <span v-else style="font-size: 22px;" @click="bookingItem.allowMerchantPromotion = !bookingItem.allowMerchantPromotion"><i class="far fa-square"></i></span>
           {{merchantItem.title}} will send you offers or news by email unless you object by unchecking this box.
        </div>
        <div class="col-12 text-left">
          <span v-if="bookingItem.allowSmtmPromotion === true" style="font-size: 22px; color: #2F77E4;" @click="bookingItem.allowSmtmPromotion = !bookingItem.allowSmtmPromotion"><i class="fas fa-check-square"></i></span>
          <span v-else style="font-size: 22px;" @click="bookingItem.allowSmtmPromotion = !bookingItem.allowSmtmPromotion"><i class="far fa-square"></i></span>
          Show Me The Menu will send you offers and news by email unless you object by unchecking this box.
        </div>
        <div class="col-12 text-center" v-if="bookingItem.deposit > 0">
          <strong>
            <span style="color:red;">Deposit of £{{(bookingItem.deposit/100.0).toFixed(2)}} is required for this date.</span>
            <br/>
            Credit Card Pre Authorisation will be processed after submission.
          </strong>
        </div>
        <div class="col-12 text-center">

          <div class="text-center">
            <br/>Your reservation request is sent to the restaurant when you submit.
            <br/>If we do not already know your email address, we will email you a verify button. Please click it when the email arrives, including if it arrives later.
            <br/>Check your spam folder and mark the email as not spam before you click the button.
            <br/>Your reservation is not confirmed until the restaurant accepts it.
          </div>
        </div>
        <div class="col-12 text-center">
          <button class="btn gray-submit-button" v-bind:class="{'enabled-black': canSubmitBooking(false) === true}" v-on:click="submitBooking" :disabled="submitting">Submit</button>
        </div>
      </div>
    </template>
    <div v-if="showCountryPicker" class="country-picker-overlay" @click.self="closeCountryPicker">
      <div class="country-picker-panel" role="dialog" aria-label="Select country code">
        <div class="country-picker-header">
          <span class="country-picker-title">Select country code</span>
          <button type="button" class="country-picker-close" @click="closeCountryPicker" aria-label="Close">&times;</button>
        </div>
        <div class="country-picker-search-wrap">
          <input
            type="search"
            class="form-control country-picker-search"
            v-model="countryFilter"
            placeholder="Search country or code"
            @keydown.esc="closeCountryPicker"
          />
        </div>
        <div class="country-picker-list" role="listbox">
          <button
            type="button"
            v-for="c in filteredCountryList"
            v-bind:key="'country-picker-' + c.code + '-' + c.name + '-' + c.mobileCode"
            class="country-picker-option"
            :class="{ 'country-picker-option--selected': bookingItem.countryCode === c.mobileCode }"
            @click="selectCountryCode(c)"
          >
            <span class="country-picker-option-flag">{{ countryCodeToFlag(c.code) }}</span>
            <span class="country-picker-option-code">{{ c.mobileCode }}</span>
            <span class="country-picker-option-name">{{ c.name }}</span>
          </button>
          <div v-if="filteredCountryList.length === 0" class="country-picker-empty">No countries found</div>
        </div>
      </div>
    </div>
    <v-dialog/>
    <div class="page-gif-loader" v-if="submitting">
      <div class="gif-loader">
        <UtensilLoader/>
        <span>Submitting...</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getBookingTimeTable,
    getBookingTypes,
    getHolidayList,
    getBookingSlots,
    submitBooking,
    bookingCardDepositPreAuthorise
  } from "../api/borium";
  import {millisToDate, getCountryCodeList, countryCodeToFlag, sortCountryCodeListForPicker, isValidPhoneNumberInput, buildContactNumber} from "../api/utils";
  import EventBus from "../api/event-bus";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import axios from "axios";
  import { showSystemDialog } from "../api/system-dialog";
  import UtensilLoader from "./UtensilLoader";
    export default {
      name: "BookingView",
      props: {
        merchantItem: {
          type:Object,
          default: function(){return false},
        },
      },
      components: {
        DatePicker,
        UtensilLoader
      },
      data() {
        return {
          bookingItem:false,
          bookingDaySchedules: [],
          bookingTypes:[],
          holidays:[],
          stripe:false,
          countryCodeList: getCountryCodeList(),
          showCountryPicker: false,
          countryFilter: '',
          submitting: false,
        }
      },
      computed: {
        selectedCountry: function() {
          if (!this.bookingItem || !this.bookingItem.countryCode) {
            return null;
          }
          for (let i = 0; i < this.countryCodeList.length; i++) {
            if (this.countryCodeList[i].mobileCode === this.bookingItem.countryCode) {
              return this.countryCodeList[i];
            }
          }
          return null;
        },
        filteredCountryList: function() {
          const query = (this.countryFilter || '').trim().toLowerCase();
          let list = this.countryCodeList;
          if (query) {
            list = list.filter(function(c) {
              return c.name.toLowerCase().indexOf(query) !== -1
                || c.mobileCode.toLowerCase().indexOf(query) !== -1
                || c.code.toLowerCase().indexOf(query) !== -1;
            });
          }
          return sortCountryCodeListForPicker(list);
        },
      },
      created() {
      },
      mounted() {
        if(this.merchantItem !== false) {
          this.getBookingInfo();
          // console.log("booking view");
          // console.log(this.merchantItem);
        }
        document.addEventListener('keydown', this.onCountryPickerKeydown);
      },
      beforeDestroy() {
        document.removeEventListener('keydown', this.onCountryPickerKeydown);
      },
      methods: {
        countryCodeToFlag: countryCodeToFlag,
        openCountryPicker: function() {
          this.$data.countryFilter = '';
          this.$data.showCountryPicker = true;
        },
        closeCountryPicker: function() {
          this.$data.showCountryPicker = false;
          this.$data.countryFilter = '';
        },
        selectCountryCode: function(country) {
          if (this.bookingItem) {
            this.bookingItem.countryCode = country.mobileCode;
          }
          this.closeCountryPicker();
        },
        onCountryPickerKeydown: function(event) {
          if (event.key === 'Escape' && this.$data.showCountryPicker) {
            this.closeCountryPicker();
          }
        },
        getBookingInfo: function() {
          let self = this;
          // console.log(this.merchantItem.merchantId);
          getBookingTypes(this.merchantItem.merchantId)
            .then(function(data){
              // console.log("booking type")
              // console.log(data);
              if(data.success === true) {
                self.$data.bookingTypes = data.item;
              }
              self.getBookingTimes();
            })
            .catch(function(err) {

            })
        },
        getBookingTimes: function() {
          let self = this;
          getBookingTimeTable(this.merchantItem.merchantId)
            .then(function(data) {
              if(data.success === true) {
                self.$data.bookingDaySchedules = data.item;
                // console.log(data.item);

                if(self.$data.bookingTypes.length === 1) {
                  self.$data.bookingItem = {
                    bookingDate:'',
                    bookingDayTime:'',
                    bookingTime:0,
                    bookingType:self.$data.bookingTypes.length === 1 ? self.$data.bookingTypes[0].title : '',
                    name:'',
                    headCount:0,
                    children:0,
                    email:'',
                    emailConfirm:'',
                    note:'',
                    countryCode:'+44',
                    phoneNumber:'',
                    contact:'',
                    subscriptionId:self.merchantItem.merchantId,
                    slots:[],
                    types:[],
                    tableType:'',
                    typeList:self.$data.bookingTypes.length === 1 ? self.$data.bookingTypes[0].types : [],
                    maxBooking: 6,
                    minBooking: 2,
                    deposit:0,
                    cancellableTime:0,
                    lastDay:null,
                    allowMerchantPromotion:true,
                    allowSmtmPromotion:true,
                  }

                  if(self.$data.bookingTypes[0].maxBooking > 0) {
                    self.$data.bookingItem.maxBooking = self.$data.bookingTypes[0].maxBooking;
                  }
                  if(self.$data.bookingTypes[0].minBooking > 0) {
                    self.$data.bookingItem.minBooking = self.$data.bookingTypes[0].minBooking;
                  }
                  if(self.$data.bookingTypes[0].slotLength > 0) {
                    let lastDay = new Date();
                    lastDay.setDate(lastDay.getDate() + self.$data.bookingTypes[0].slotLength);
                    self.$data.bookingItem.lastDay = millisToDate(lastDay.getTime());
                  }
                }

                self.getHolidayList();
              }

            })
            .catch(function(err) {

              // console.log(err);
              // if(err.response !== undefined) {
              //   console.log(err.response);
              // }
            })
        },
        getHolidayList: function() {
          // console.log("get holiday list");
          let self = this;
          let today = millisToDate(new Date().getTime(), '-');

          getHolidayList(this.merchantItem.merchantId, today)
            .then(function(data) {
              // console.log("holiday response");
              // console.log(data);
              if(data.success === true) {
                self.$data.holidays = data.item;
              }
            })
            .catch(function(err) {
              // console.log(err);
              // if(err.response !== undefined) {
              //   console.log(err.response);
              // }
            })
        },
        canSubmitBooking: function(showDialog = true) {
          if(this.$data.bookingItem == null || this.$data.bookingItem === false) {

            return false;
          }

          if(this.$data.bookingItem.typeList !== null && this.$data.bookingItem.typeList.length > 0 && (this.$data.bookingItem.types === null || this.$data.bookingItem.types.length === 0)) {
            if(showDialog) this.showDialog("Please select table type");
            return false;
          }
          let todayText = millisToDate();
          if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
            || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00'
            ||this.$data.bookingItem.bookingDate < todayText ) {
            if(showDialog) this.showDialog("Date cannot be earlier than today");
            return false;
          }

          if(this.$data.bookingItem.bookingTime === 0) {
            if(showDialog) this.showDialog("Please select time");
            return false;
          }

          if(this.$data.bookingItem.name === null || this.$data.bookingItem.name === '' || this.$data.bookingItem.name.length < 2) {
            if(showDialog) this.showDialog("Please enter your name");
            return false;
          }
          if(this.$data.bookingItem.headCount === 0) {
            if(showDialog) this.showDialog("Please enter number of people");
            return false;
          }
          if(!isValidPhoneNumberInput(this.$data.bookingItem.phoneNumber)) {
            if(showDialog) this.showDialog("Please enter phone number");
            return false;
          }
          if(this.$data.bookingItem.email === null || this.$data.bookingItem.email.includes("@") === false) {
            if(showDialog) this.showDialog("Please enter correct email address");
            return false;
          }
          if(this.$data.bookingItem.emailConfirm == null || this.$data.bookingItem.emailConfirm.includes("@") === false) {
            if(showDialog) this.showDialog("Please enter confirmation email");
            return false;
          }
          if(this.$data.bookingItem.email !== this.$data.bookingItem.emailConfirm) {
            if(showDialog) this.showDialog("Email addresses are not matching");
            return false;
          }
          // console.log("submittable")
          return true;
        },
        submitBooking: function() {
          if(this.canSubmitBooking()==false) {
            return;
          }

          for(let i = 0 ; i < this.$data.bookingItem.slots.length ; i++) {
            if(this.$data.bookingItem.slots[i].time === this.$data.bookingItem.bookingTime) {
              this.$data.bookingItem.bookingDayTime = this.$data.bookingItem.slots[i].text;
              break;
            }
          }

          // console.log("submit")
          // console.log(this.$data.bookingItem);
          this.$data.bookingItem.contact = buildContactNumber(this.$data.bookingItem.countryCode, this.$data.bookingItem.phoneNumber);
          this.submitting = true;
          EventBus.$emit("showLoading", true, "Submitting...");
          let self = this;
          submitBooking(this.$data.bookingItem)
            .then(function(data) {
              self.submitting = false;
              EventBus.$emit("showLoading", false);
              if(data.success === true) {
                let submitted = data.item;
                self.$data.bookingItem = {
                  bookingDate:'',
                  bookingDayTime:'',
                  bookingTime:0,
                  name:'',
                  headCount:0,
                  children:0,
                  infants:0,
                  email:'',
                  emailConfirm:'',
                  note:'',
                  countryCode:'+44',
                  phoneNumber:'',
                  contact:'',
                  subscriptionId:self.merchantItem.merchantId,
                  slots:[],
                  types:[],
                  tableType:'',
                  typeList:[],
                  deposit:0,
                  cancellableTime:0,
                  allowMerchantPromotion:true,
                  allowSmtmPromotion:true,
                }
                self.showSubmittedBooking(submitted);
                if(submitted && submitted.deposit > 0) {
                  self.processToPayDeposit(submitted.id);
                  return;
                }
                self.getBookingInfo();
              } else {
                self.showDialog(data.message);
              }
            })
            .catch(function(err) {
              self.submitting = false;
              EventBus.$emit("showLoading", false);

              console.error('Request failed', err && err.response ? err.response.status : '');
              self.showDialog("There was an error. Please check email if you received email.", "Something went wrong!");
            })
        },
        showSubmittedBooking: function(item) {
          const needsVerify = !!(item && item.emailVerified !== true && item.subscriptionId > 0);
          const confirmed = item && item.state === 10;
          const title = needsVerify
            ? 'Booking Submitted'
            : (confirmed ? 'Your booking has been successfully made.' : 'Your booking request has been submitted.');
          this.showDialog(this.buildSubmittedBookingMessage(item, needsVerify, confirmed), title, needsVerify ? "I'll check my email" : 'Close');
        },
        buildSubmittedBookingMessage: function(item, needsVerify, confirmed) {
          const esc = function(value) {
            return String(value == null ? '' : value)
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;');
          };
          const email = item && item.email ? esc(item.email) : 'your email address';
          let msg = '';
          msg += this.buildSubmittedBookingDetails(item, esc);
          msg += '<div style="font-size:15px;line-height:1.5;color:#444;margin:0 0 16px 0;">';
          if (confirmed) {
            msg += '<p style="margin:0;">A confirmation email is on its way. If the restaurant needs to change the booking, they will let you know.</p>';
          } else {
            msg += '<p style="margin:0;">Your request is with the restaurant. <strong>It is not confirmed</strong> until they accept it. You will get another email when they do.</p>';
          }
          msg += '</div>';
          if (needsVerify) {
            msg += '<div style="background:#fff6e8;border:2px solid #e6a817;border-radius:12px;padding:16px;margin:0 0 16px 0;">';
            msg += '<div style="font-size:12px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#8a5a00;">Action needed</div>';
            msg += '<div style="margin-top:6px;font-size:20px;line-height:1.3;font-weight:700;color:#1b1b1f;">Click Verify email address</div>';
            msg += '<p style="margin:10px 0 0 0;font-size:15px;line-height:1.5;color:#3c3c3b;">We are sending a message to <strong>' + email + '</strong>. Open it and press the <strong>Verify email address</strong> button. You can do this when the email arrives, even if it comes later.</p>';
            msg += '<div style="margin-top:12px;background:#fff;border-radius:8px;padding:10px 12px;font-size:14px;line-height:1.45;color:#3c3c3b;">Look in your spam folder. If it is there, mark it as not spam, then click the button.</div>';
            msg += '</div>';
          }
          if (this.merchantItem && this.merchantItem.contact !== null) {
            const address = esc(this.merchantItem.address).replace(/\n/g, '<br/>');
            msg += '<div style="margin-top:14px;padding-top:12px;border-top:1px solid #eee;font-size:14px;line-height:1.45;color:#555;"><strong>' + esc(this.merchantItem.title) + '</strong><br/>Tel: ' + esc(this.merchantItem.contact) + '<br/>' + address + '</div>';
          }
          return msg;
        },
        buildSubmittedBookingDetails: function(item, esc) {
          if (!item) {
            return '';
          }
          const when = item.bookingTimeLocale || item.bookingDateTime || [item.bookingDate, item.bookingDayTime].filter(Boolean).join(' ');
          const adults = Number(item.headCount) || 0;
          const children = Number(item.children) || 0;
          const infants = Number(item.infants) || 0;
          let guests = '';
          if (adults > 0) {
            guests = adults + (adults === 1 ? ' person' : ' people');
          }
          if (children > 0) {
            guests += (guests ? ' + ' : '') + children + (children === 1 ? ' child' : ' children');
          }
          if (infants > 0) {
            guests += (guests ? ' + ' : '') + infants + (infants === 1 ? ' toddler' : ' toddlers');
          }
          const selection = item.types && item.types.length ? item.types.join(', ') : '';
          let html = '<div style="background:#f7f7f8;border-radius:12px;padding:14px 16px;margin:0 0 16px 0;">';
          html += '<div style="font-size:12px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#666;">Your booking</div>';
          if (when) {
            html += '<div style="margin-top:8px;font-size:18px;line-height:1.3;font-weight:700;color:#1b1b1f;">' + esc(when) + '</div>';
          }
          if (Number(item.duration) > 0) {
            html += '<div style="margin-top:4px;font-size:15px;color:#3c3c3b;">' + esc(item.duration) + ' minutes</div>';
          }
          if (guests) {
            html += '<div style="margin-top:4px;font-size:15px;color:#3c3c3b;">' + esc(guests) + '</div>';
          }
          if (item.name) {
            html += '<div style="margin-top:8px;font-size:15px;color:#3c3c3b;">Name: ' + esc(item.name) + '</div>';
          }
          if (item.bookingType) {
            html += '<div style="margin-top:4px;font-size:15px;color:#3c3c3b;">Booking type: ' + esc(item.bookingType) + '</div>';
          }
          if (selection) {
            html += '<div style="margin-top:4px;font-size:15px;color:#3c3c3b;">Selection: ' + esc(selection) + '</div>';
          }
          if (item.note) {
            html += '<div style="margin-top:8px;font-size:15px;line-height:1.45;color:#3c3c3b;"><strong>Special request</strong><br/>' + esc(item.note) + '</div>';
          }
          if (item.id) {
            html += '<div style="margin-top:8px;font-size:13px;color:#666;">Reference #' + esc(item.id) + '</div>';
          }
          html += '</div>';
          return html;
        },
        processToPayDeposit: function(id) {
          let self = this;
          bookingCardDepositPreAuthorise(id)
          .then(function(data) {
            if(data.success === true) {
              if (data.item && data.item.teyaSessionUrl) {
                window.location.href = data.item.teyaSessionUrl;
                return;
              }
              self.startStripPayment(data.item, data.message);
            } else {
              self.showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.error('Request failed', err && err.response ? err.response.status : '');
          })
        },
        startStripPayment: function(item, key) {
          // this.$data.stripe = Stripe('pk_test_51HKwg5FVWak6exTyYpcPbHzjlLTXgLzPJBU1hx7FPgImJOB6psptYrcyP53K75Hy6OXvoeTahf91fUzWqzQxlzt7000Vvir4GN');
          // console.log("start stripe payment " + key);
          this.$data.stripe = Stripe(key);
          this.$data.stripe.redirectToCheckout({ sessionId: item.stripeSessionId });

        },
        selectSubType: function(type) {
          this.$data.bookingItem.types = [type];
          this.$data.bookingItem.tableType = type;
        },
        isTypeSelected: function(type) {

          for(let i = 0 ; i < this.$data.bookingItem.types.length ; i++) {
            if(this.$data.bookingItem.types[i] === type) {
              return true;
            }
          }
          return false;
        },
        onTypeSelected: function(type) {
          if(type === this.$data.bookingItem.bookingType) {
            return;
          }
          this.$data.bookingItem = {
            bookingDate:'',
            bookingDayTime:'',
            bookingTime:0,
            bookingType:'',
            name:'',
            headCount:0,
            children:0,
            infants:0,
            email:'',
            emailConfirm:'',
            note:'',
            countryCode:'+44',
            phoneNumber:'',
            contact:'',
            subscriptionId:this.merchantItem.merchantId,
            slots:[],
            types:[],
            tableType:'',
            typeList:this.$data.bookingTypes.length === 1 ? this.$data.bookingTypes[0].types : [],
            maxBooking: 20,
            deposit:0,
            cancellableTime:0,
            lastDay:null,
            allowMerchantPromotion:true,
            allowSmtmPromotion:true,
          }
          this.$data.bookingItem.bookingType = type.title;
          this.$data.bookingItem.bookingDate = "";
          this.$data.bookingItem.slots = [];
          this.$data.bookingItem.bookingTime = 0;
          this.$data.bookingItem.bookingEndTime = 0;
          this.$data.bookingItem.types = [];
          this.$data.bookingItem.deposit = 0;
          this.$data.bookingItem.typeList = type.types;
          this.$data.bookingItem.maxBooking = type.maxBooking > 0?type.maxBooking:20;
          this.$data.bookingItem.minBooking = type.minBooking > 0?type.minBooking:2;
          this.$data.bookingItem.cancellableTime = 0;
          this.$data.bookingItem.lastDay = null;

          if(type.slotLength > 0) {
            let lastDay = new Date();
            lastDay.setDate(lastDay.getDate() + type.slotLength);
            this.$data.bookingItem.lastDay = millisToDate(lastDay.getTime());
          }

        },

        onBookingDateSelected: function() {
          if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
            || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00') {
            return false;
          }
          this.$data.bookingItem.slots = [];
          this.$data.bookingItem.bookingTime = 0;
          this.$data.bookingItem.bookingEndTime = 0;
          this.$data.bookingItem.headCount = 0;
          this.$data.bookingItem.children = 0;
          this.$data.bookingItem.infants = 0;
          this.$data.bookingItem.deposit = 0;
          this.$data.bookingItem.depositPerPerson = 0;
          this.$data.bookingItem.duration = 0;
          this.$data.bookingItem.cancellableTime = 0;
          this.loadLondonSlots();
        },
        loadLondonSlots: function() {
          let self = this;
          getBookingSlots(this.merchantItem.merchantId, this.$data.bookingItem.bookingDate, this.$data.bookingItem.bookingType)
            .then(function(data) {
              if(data.success !== true || data.item == null) {
                self.$data.bookingItem.bookingDate = '';
                self.$data.bookingItem.slots = [];
                self.showDialog(data.message || "This date is not available");
                return;
              }
              let list = data.item;
              self.$data.bookingItem.slots = list.slots || [];
              if(list.minBooking > 0) {
                self.$data.bookingItem.minBooking = list.minBooking;
              }
              if(list.maxBooking > 0) {
                self.$data.bookingItem.maxBooking = list.maxBooking;
              }
              if(list.deposit > 0) {
                self.$data.bookingItem.depositPerPerson = list.deposit;
                self.$data.bookingItem.deposit = list.deposit;
              }
            })
            .catch(function(err) {
              console.error('Request failed', err && err.response ? err.response.status : '');
              self.$data.bookingItem.bookingDate = '';
              self.showDialog("There was an error. Please try again.");
            })
        },
        onHeadCountChanged: function() {
          if(this.$data.bookingItem.depositPerPerson > 0) {
            this.$data.bookingItem.deposit = this.$data.bookingItem.depositPerPerson* this.$data.bookingItem.headCount;
          }
        },
        timeSelected: function() {
          this.$data.bookingItem.cancellableTime = 0;
          this.$data.bookingItem.headCount = 0;
          this.$data.bookingItem.children = 0;
          this.$data.bookingItem.infants = 0;
          for(let i = 0 ; i < this.$data.bookingItem.slots.length ; i++) {
            if(this.$data.bookingItem.bookingTime === this.$data.bookingItem.slots[i].time) {
              this.$data.bookingItem.cancellableTime = this.$data.bookingItem.slots[i].cancellableTime;
              this.$data.bookingItem.duration = this.$data.bookingItem.slots[i].length;
              this.$data.bookingItem.bookingEndTime = this.$data.bookingItem.bookingTime+(this.$data.bookingItem.slots[i].length*60000);
              this.$data.bookingItem.minBooking = this.$data.bookingItem.slots[i].minGuest;
              this.$data.bookingItem.maxBooking = this.$data.bookingItem.slots[i].maxGuest;
              return;
            }
          }
        },
        showDialog: function(message, title = '', closeText) {
          showSystemDialog({
            title,
            content: message,
            closeText: closeText || 'Close',
          });
        }
      }
    }
</script>

<style scoped>
.booking-form-row input, select, select:disabled, .phone-input-row .phone-country-select {
  height: 62px;
  line-height: 64px;
  border: none;
  background-color: white;

}
select option:first-of-type {
  color: red;
}
.booking-form-row textarea {
  border: none;
}
.white-input {
  height: 62px;
  background-color: #FFF;
  padding:12px 0;
}
.date-picker {
  border: unset;
  background-color: white;
  padding-left: 10px;
}

.gray-submit-button {
  background: #ABABAB;
  color: white;
  padding: 18px 84px;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;


  text-align: center;
  letter-spacing: 0.1em;
  border-radius: 10px;
}
.enabled-black {
  background-color: #333;
}
.phone-input-row {
  display: flex;
  align-items: stretch;
}
.phone-input-row .phone-country-select {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  max-width: none;
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: 1px solid #e8e8e8;
  padding: 0 0.45rem 0 0.65rem;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.35rem;
  cursor: pointer;
  text-align: left;
  line-height: 1;
  box-sizing: border-box;
}
.phone-country-selected {
  white-space: nowrap;
  flex: 0 0 auto;
}
.phone-country-chevron {
  font-size: 0.65rem;
  color: #666;
  flex: 0 0 auto;
  margin-left: 0.1rem;
}
.phone-input-row .phone-number-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 62px;
  line-height: 64px;
  border-radius: 0 0.25rem 0.25rem 0;
  box-sizing: border-box;
}
.country-picker-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}
.country-picker-panel {
  width: min(420px, 100%);
  max-height: min(70vh, 560px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}
.country-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 10px;
  border-bottom: 1px solid #eee;
}
.country-picker-title {
  font-size: 1rem;
  font-weight: 600;
  color: #222;
}
.country-picker-close {
  border: none;
  background: #333;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
}
.country-picker-search-wrap {
  padding: 12px 16px 0;
  box-sizing: border-box;
}
.country-picker-search {
  width: 100%;
  max-width: 100%;
  height: 44px;
  line-height: 44px;
  margin: 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
}
.country-picker-list {
  margin-top: 12px;
  padding: 0 8px 12px;
  overflow-y: auto;
  flex: 1 1 auto;
}
.country-picker-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: none;
  background: transparent;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
}
.country-picker-option:hover,
.country-picker-option--selected {
  background: #f3f6fa;
}
.country-picker-option-flag {
  flex: 0 0 auto;
  font-size: 1.2rem;
  line-height: 1;
}
.country-picker-option-code {
  flex: 0 0 auto;
  min-width: 3.5rem;
  font-weight: 600;
  color: #222;
}
.country-picker-option-name {
  flex: 1 1 auto;
  min-width: 0;
  color: #444;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.country-picker-empty {
  padding: 24px 12px;
  text-align: center;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/BookingView.vue